import { trans } from '@/helpers/trans'
import { ShiftExchangeStatus } from '@/models'
import { CardColor } from '@/types'

export function getShiftExchangeStatus(
    status: ShiftExchangeStatus,
):{ color: CardColor, text: string } {
    if (status === ShiftExchangeStatus.approvedByEmployee) {
        return { color: CardColor.orange, text: trans('common.available') }
    }

    if (status === ShiftExchangeStatus.approvedByManager) {
        return { color: CardColor.success, text: trans('common.planned') }
    }

    if (status === ShiftExchangeStatus.declined) {
        return { color: CardColor.danger, text: trans('pages.exchanges.denied') }
    }

    return { color: CardColor.secondary, text: trans('pages.exchanges.exchangeShift') }
}
